import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import Checkbox from 'meinian-package/src/baseComponent/checkbox'
import Input from 'meinian-package/src/baseComponent/input'
import Icon from 'meinian-package/src/component/icon'
import request from 'meinian-package/src/utils/request'
import Dropdown from 'meinian-package/src/baseComponent/dropdown'
import './intelligent.less'

const convertIns = (result) => {
  const all = [{ label: '我拥有的', value: 1, children: result.ownerList.map(m => ({ label: m.name, value: m.id, })) },
    { label: '我协作的', value: 2, children: result.cooperationList.map(m => ({ label: m.name, value: m.id, prefix: '(协作)' })) }]
  return all
}
const convertUser = (result) => {
  return result.map(m => ({ label: m.userName, value: m.userId }))
}
const LABEL = {
  INS_MY: '我拥有的',
  INS_COOP: '我协作的',
  COLLECTOR: '采集用户'
}
export default (props) => {
  const { genderList, value = {}, onChange } = props
  const [label, setLabel] = useState()
  const [dropVisible, setDropVisible] = useState(false)
  const [insList, setInsList] = useState()
  const [userList, setUserList] = useState()
  const [myInsList, setMyInsList] = useState([])
  const [coopInsList, setCoopInsList] = useState([])
  const [selectedIns, setSelectedIns] = useState([])
  const [selectedUser, setSelectedUser] = useState([])

  useEffect(() => {
    fetchIns()
    fetchUsers()
  }, [])
  useEffect(() => {
    setSelectedUser(userList?.filter(m => value?.userIdList?.indexOf(m.value) > -1))
    setMyInsList(insList?.filter(l => l.label === LABEL.INS_MY)?.[0].children.filter(m => value?.inspirationIdList?.indexOf(m.value) > -1))
    setCoopInsList(insList?.filter(l => l.label === LABEL.INS_COOP)?.[0].children.filter(m => value?.inspirationIdList?.indexOf(m.value) > -1))
  }, [value, insList])
  useEffect(() => {
    setSelectedIns([...(myInsList || []), ...(coopInsList || [])])
  }, [JSON.stringify(myInsList), JSON.stringify(coopInsList)])
  const fetchIns = async () => {
    const res = await request.get('/zhikuan/ins/inspiration/selector', { queryType: 3, rankStatus: -2 }, 'MNInspirationSearch')
    setInsList(convertIns(res))
  }
  const fetchUsers = async () => {
    try {
      const res = await request.get('/zhikuan/ins/inspiration/user-selector')
      setUserList(convertUser(res))
    } catch (err) {
      console.error(err)
    }
  }
  const onDeleteIns = (ins) => {
    onChange(pre => ({ ...pre, inspirationIdList: pre.inspirationIdList.filter(m => m !== ins) }))
  }
  const onDeleteUser = (user) => {
    onChange(pre => ({ ...pre, userIdList: pre.userIdList.filter(m => m !== user) }))
  }

  return <div className="meinian-intelligent-filter">
    <Dropdown
      trigger="hover"
      className="meinian-intelligent-filter-modal"
      overlay={<span className="content" style={{ display: 'flex' }}>
        <div className="left">
          <div className="title">行业</div>
          <div className="sub-titles-wrap">
            {genderList?.map(gender => <div className={classNames('sub-title', { active: value.gender === gender })} onClick={() => { onChange(pre => ({ ...pre, gender })) }} onMouseEnter={() => setLabel('')}>
              <Icon type="m-xiaoyan" style={{ margin: '0 12px 0 8px', fontSize: 16, opacity: value.gender === gender ? 0.72 : 0 }} />
              <span>{gender}</span>
            </div>)}
          </div>
          <div className="title">
            <span>灵感集</span>
            <span className="clear" onClick={() => onChange(pre => ({ ...pre, inspirationIdList: [] }))}>清除</span>
          </div>
          <div className="sub-titles-wrap">
            <div className={classNames('sub-title', { active: label === LABEL.INS_MY })} onMouseEnter={() => { setLabel(LABEL.INS_MY) }}>{myInsList?.length ? <span className="count">{myInsList.length}</span> : null}<span style={{ margin: '0 32px' }}>我拥有的</span><Icon type="m-Vxing_you" /></div>
            <div className={classNames('sub-title', { active: label === LABEL.INS_COOP })} onMouseEnter={() => { setLabel(LABEL.INS_COOP) }}>{coopInsList?.length ? <span className="count">{coopInsList.length}</span> : null}<span style={{ margin: '0 32px' }}>我协作的</span><Icon type="m-Vxing_you" /></div>
          </div>
          <div className="title">
            <span>采集用户</span>
            <span className="clear" onClick={() => onChange(pre => ({ ...pre, userIdList: [] }))}>清除</span>
          </div>
          <div className="sub-titles-wrap">
            <div className={classNames('sub-title', { active: label === LABEL.COLLECTOR })} onMouseEnter={() => { setLabel(LABEL.COLLECTOR) }}>
              {selectedUser?.length ? <span className="count">{selectedUser?.length}</span> : null}
              <span style={{ margin: '0 32px' }}>全部用户</span><Icon type="m-Vxing_you" />
            </div>
          </div>
        </div>
        <div className="right" style={{ display: label ? 'block' : 'none' }}>
          <RightFilter value={value} label={label} data={label === LABEL.COLLECTOR ? userList : insList} onChange={props.onChange} />
        </div>
      </span>}
      visible={dropVisible}
      onVisibleChange={visible => setDropVisible(visible)}
    >
      <span className="filter-header"><span className="gender-title">{value.gender}</span><Icon type="m-Vxing_xia" /></span>
    </Dropdown>
    {value.inspirationIdList?.length || value.userIdList?.length ? <div className="sub-filter">
      {value.inspirationIdList?.length ? <div className="selected-items-wrap">
        <span className="label">灵感集</span>
        <span className="item-wrap">{value.inspirationIdList?.length <= 3 ? selectedIns?.map(ins => <span onClick={() => onDeleteIns(ins.value)}>{ins.label}<Icon type="m-guanbi" /></span>) : <>
          <span onClick={() => onDeleteIns(selectedIns?.[0].value)}>{selectedIns?.[0]?.label}<Icon type="m-guanbi" /></span>
          <span onClick={() => onDeleteIns(selectedIns?.[1].value)}>{selectedIns?.[1]?.label}<Icon type="m-guanbi" /></span>
          <span>...</span>
          <span onClick={() => onDeleteIns(selectedIns?.[selectedIns.length - 1].value)}>{selectedIns?.[selectedIns.length - 1]?.label}<Icon type="m-guanbi" /></span>
        </>}
        </span>
      </div> : null}
      {value.inspirationIdList?.length && value.userIdList?.length ? <div className="divide-line" /> : null}
      {value.userIdList?.length ? <div className="selected-items-wrap">
        <span className="label">采集用户</span>
        <span className="item-wrap">{value.userIdList?.length <= 3 ? selectedUser?.map(user => <span onClick={() => onDeleteUser(user.value)}>{user.label}<Icon type="m-guanbi" /></span>) : <>
          <span onClick={() => onDeleteUser(selectedUser?.[0]?.value)}>{selectedUser?.[0]?.label}<Icon type="m-guanbi" /></span>
          <span onClick={() => onDeleteUser(selectedUser?.[1]?.value)}>{selectedUser?.[1]?.label}<Icon type="m-guanbi" /></span>
          <span>...</span>
          <span onClick={() => onDeleteUser(selectedUser?.[selectedUser.length - 1]?.value)}>{selectedUser?.[selectedUser.length - 1]?.label}<Icon type="m-guanbi" /></span>
        </>}
        </span>
      </div> : null}
    </div> : null}
  </div>
}
const RightFilter = (props) => {
  const { data, label, onChange, value = {} } = props
  const [keyWords, setKeyWords] = useState('')
  useEffect(() => {
    getData(keyWords)
  }, [keyWords])
  const getData = (_keyWords) => {
    if (label === LABEL.COLLECTOR) {
      return data.filter(l => (_keyWords ? l.label.includes(_keyWords) : true))
    }
    return data?.filter(l => l.label === label)?.[0]?.children?.filter(m => (keyWords ? m.label.includes(keyWords) : true))
  }
  const list = label == LABEL.COLLECTOR ? value.userIdList : value.inspirationIdList
  const onClickItem = (item) => {
    const index = list?.indexOf(item)
    if (index > -1) {
      list.splice(index, 1)
    } else {
      list.push(item)
    }
    if (label === LABEL.COLLECTOR) {
      onChange && onChange(pre => ({ ...pre, userIdList: list }))
      return
    }
    onChange && onChange(pre => ({ ...pre, inspirationIdList: list }))
  }
  return <div className="right-content-wrap" style={{ height: 455 }}>
    <div className="intelligent-search-wrap">
      <Input.Search
        wrapClassName="search"
        placeholder="请输入关键字搜索"
        value={keyWords}
        onChange={_keyWords => setKeyWords(_keyWords)}
      />
    </div>
    <div className="items-wrap">
      {getData(keyWords)?.length ? getData(keyWords)?.map(m => <div className={classNames('item', { active: list?.indexOf(m.value) > -1 })} style={{ display: 'flex' }} onClick={() => onClickItem(m.value)}>
        <Checkbox checked={list?.indexOf(m.value) > -1} />
        <span className="label">{m.label}</span>
      </div>) : <div className="empty">暂无分类结果</div>}
    </div>
  </div>
}
